import React from 'react';

import {
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  BaseAccordion,
  LegalTermDetailModal
} from 'modules';



const ContentText = styled(Typography)({
  color: '#1E3949',
  opacity: 0.54,
  fontSize: 14,
  fontWeight: 400
});

interface IProps {
  title: string;
  content: string;
  isExpanded: boolean;
  onExpand?: (expanded: boolean) => void;
}

export const TermAccordion: React.FC<IProps> = props => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  React.useEffect(() => {
    setIsExpanded(props.isExpanded);
  }, [props.isExpanded]);



  return (
    <BaseAccordion.FC
      title={props.title}
      isExpanded={isExpanded}
      onExpand={isExpanded => setIsExpanded(isExpanded)}>
      <Stack spacing={2.5}>
        <ContentText>{props.content}</ContentText>
        <LegalTermDetailModal.FC title={props.title}/>
      </Stack>
    </BaseAccordion.FC>
  );
};
